import styled from "styled-components";

export const SelectWrapper = styled.select`
    background-color: var(--blue-green);
`;
